import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import kebabCase from 'lodash/kebabCase.js';
import { tokens } from '@everfi/design-system';
import { Layout } from '../../core/components/Layout/component.js';
import { Tag } from '../../core/components/Tag/component.js';
import { TagSize } from '../../core/components/Tag/types.js';
import { Icon } from '../../core/components/Icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var _excluded = ["canClose", "category", "data", "disabled", "onClick", "onRemove", "sortable", "value"];
var Chip = function Chip(_ref) {
  var _ref$canClose = _ref.canClose,
    canClose = _ref$canClose === void 0 ? true : _ref$canClose,
    category = _ref.category,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    _ref$onRemove = _ref.onRemove,
    onRemove = _ref$onRemove === void 0 ? function () {} : _ref$onRemove,
    sortable = _ref.sortable,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  // @ts-ignore
  var getChipClasses = function getChipClasses() {
    return _formatClassName(['chip', {
      disabled: disabled
    }]);
  };
  var getDataAttributes = function getDataAttributes(data) {
    var dataProps = {};
    if (data.action) {
      dataProps['data-action'] = data.action;
    }
    if (data.objectId) {
      dataProps['data-object-id'] = data.objectId;
    }
    if (data.objectType) {
      dataProps['data-object-type'] = data.objectType;
    }
    if (data.componentType) {
      dataProps['data-component-type'] = data.componentType;
    } else {
      dataProps['data-component-type'] = value ? "".concat(kebabCase(value), "-chip") : 'chip';
    }
    return dataProps;
  };
  var performOnMouseDown = function performOnMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
  };
  var performOnClick = function performOnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled && onClick) {
      onClick();
    }
  };
  var performOnRemove = function performOnRemove(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) {
      onRemove();
    }
  };
  var dataAttributes = getDataAttributes(data);
  return /*#__PURE__*/React.createElement(Layout, _extends({
    as: "button",
    className: getChipClasses(),
    onMouseDown: performOnMouseDown,
    onClick: performOnClick,
    borderRadius: tokens.BorderRadiiSm
  }, props, dataAttributes), /*#__PURE__*/React.createElement(Tag, {
    colorScheme: disabled ? 'gray' : 'brand',
    size: TagSize.MEDIUM,
    isClosable: canClose,
    closeClick: performOnRemove
  }, sortable && /*#__PURE__*/React.createElement(Icon, {
    iconName: "grip-lines",
    prefix: "far"
  }), category && /*#__PURE__*/React.createElement(Layout, {
    as: "span",
    fontWeight: "bold",
    whiteSpace: "nowrap"
  }, category, value && ': '), value));
};
Chip.displayName = "Chip";
Chip.displayName = 'Chip';
export { Chip };